import { Navigate, Outlet } from "react-router-dom"
import React from "react"
import { AuthData, useAuth } from "context/AuthProvider"
import { Puff } from "react-loader-spinner"

const Authmiddleware = (props: any) => {
  const [user, , , authLoading] = useAuth() as AuthData
  const token = localStorage.getItem("token")
  const isValidToken = !!token && !["null", "undefined", "", "[object Object]"].includes(token.trim()) && token.trim().split(".").length === 3

  if(!isValidToken) {
    localStorage.removeItem("token");
    return <Navigate to={{ pathname: "/signin" }}  replace />
  } else {
    if (!authLoading) {
      if (user?.role === props.allowed) {
        return <Outlet />
      } else {
        return <Navigate to={{ pathname: "/not-found" }} replace />
      }
    } else {
      return <div className="d-flex justify-content-center align-items-center " style={{ height: "500px" }}>
      <Puff color="#FFD0B8" height={50} width={50} />
    </div>
    }
  }
}

export default Authmiddleware
